// extracted by mini-css-extract-plugin
export default {"ContextMenu":"TableContextMenu_ContextMenu__LjeDh","MenuOption":"TableContextMenu_MenuOption__oCWue"};